"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ButtonText = exports.DarkButton = exports.TertiaryButton = exports.SecondaryButton = exports.PrimaryButton = void 0;
var button_1 = require("./button");
Object.defineProperty(exports, "PrimaryButton", { enumerable: true, get: function () { return button_1.PrimaryButton; } });
Object.defineProperty(exports, "SecondaryButton", { enumerable: true, get: function () { return button_1.SecondaryButton; } });
Object.defineProperty(exports, "TertiaryButton", { enumerable: true, get: function () { return button_1.TertiaryButton; } });
Object.defineProperty(exports, "DarkButton", { enumerable: true, get: function () { return button_1.DarkButton; } });
var button_2 = require("./styles/button");
Object.defineProperty(exports, "ButtonText", { enumerable: true, get: function () { return button_2.ButtonText; } });
//# sourceMappingURL=index.js.map